export default "__VITE_ASSET__26ea2acd__"